import { logger } from './logger';

interface ErrorWithContext extends Error {
  context?: Record<string, any>;
}

class ErrorMonitoring {
  private isInitialized = false;

  initialize() {
    if (this.isInitialized) return;

    window.addEventListener('error', (event) => {
      this.captureError(event.error);
    });

    window.addEventListener('unhandledrejection', (event) => {
      this.captureError(event.reason);
    });

    this.isInitialized = true;
  }

  captureError(error: Error | unknown, context?: Record<string, any>) {
    const errorObject = error instanceof Error ? error : new Error(String(error));
    
    if (context) {
      (errorObject as ErrorWithContext).context = context;
    }

    logger.error(errorObject.message, {
      stack: errorObject.stack,
      context: (errorObject as ErrorWithContext).context,
    });

    // In production, you would send this to your error monitoring service
    if (import.meta.env.PROD) {
      // Send to monitoring service
    }
  }

  setUser(userId: string, email?: string) {
    // Set user context for error monitoring
  }

  clearUser() {
    // Clear user context
  }
}

export const errorMonitoring = new ErrorMonitoring();